import styled from "styled-components"

type TooltipIndicatorProps = React.HTMLAttributes<HTMLDivElement> & {
  color?: string
}

export const TooltipIndicator: React.FC<TooltipIndicatorProps> = ({ color, ...props }) => {
  return (
    <TooltipContainer $color={color} {...props}>
      ?
    </TooltipContainer>
  )
}

const TooltipContainer = styled.div<{ $color?: string }>`
  border-width: 1.1px;
  border-style: solid;
  border-radius: 50%;
  font-size: 0.8rem;
  cursor: pointer;
  width: 1.2rem;
  height: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  &:not(.black) {
    border-color: ${({ theme, $color }) => ($color ? $color : theme.neutralColor400)};
    color: ${({ theme, $color }) => ($color ? $color : theme.neutralColor400)};
  }
`
export default TooltipIndicator
